/**
 * LWP's write-up admin pages (wave 1). LOANS_WRITEUP_PAGES maps each pcb-loans-api capability action id to its path under /loans;
 * LoansArea spreads it into LOANS_ACTION_PAGES and App.tsx registers one <Route> per entry (ROP wires the /loans routes).
 *
 * monitoring.approvals and monitoring.jobs are not in v3/loans/admin/capabilities yet - LOP adds them; until then the pages
 * are reachable by their path but not listed on the Loans home.
 */

import type { ComponentType } from 'react';
import { LoansFindPage } from './find/FindPage';
import { LoansApprovalsPage, LoansScheduledJobsPage } from './monitoring/MonitoringPages';
import { LoansJxProbePage } from './tools/JxProbePage';
// LOP's own Tools page, registered here because App.tsx already routes every entry of this map (no App.tsx edit needed).
import { LoansTestCardPage } from '../tools/TestCardPage';

export interface LoansWriteupPage {
  /** Path under /loans, as App.tsx registers it. */
  path: string;
  element: ComponentType;
}

export const LOANS_WRITEUP_PAGES: Record<string, LoansWriteupPage> = {
  'find.records': { path: 'find/records', element: LoansFindPage },
  'monitoring.approvals': { path: 'monitoring/approvals', element: LoansApprovalsPage },
  'monitoring.jobs': { path: 'monitoring/jobs', element: LoansScheduledJobsPage },
  'tools.jx-probe': { path: 'tools/jx-probe', element: LoansJxProbePage },
  'tools.test-card': { path: 'tools/test-card', element: LoansTestCardPage },
};

export { LoansFindPage, LoansApprovalsPage, LoansScheduledJobsPage, LoansJxProbePage };
